import { PlaceholdersId, TFComponent } from '@types';
import { CostSummaryPlaceholder } from './costSummary';

export const costSummary: TFComponent = {
	component: CostSummaryPlaceholder,
	id: PlaceholdersId.costSummary,
	name: 'costSummary',
};
